import { motion } from "framer-motion";
import "../index.css";
import FloatingTechIcons from "../components/FloatingTechIcons";
import CustomCursor from "../components/CustomCursor";
import ParticlesComponent from "../components/particles";
import { FaRegHandPaper } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.5,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 60, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 80,
      damping: 12,
    },
  },
};

export default function Home() {
   const navigate = useNavigate();
  return (

    <>
      <CustomCursor />
      <main className="pt-2 bg-black ...">
        <main className="min-h-screen bg-animated-gradient text-white px-4 sm:px-6 py-12 flex flex-col justify-center items-center overflow-hidden relative text-center">
          {/* Background Particles */}
          <div className="absolute inset-0 z-0">
            <ParticlesComponent />
          </div>

          {/* Floating Icons */}
          <div className="hidden md:block">
            <FloatingTechIcons />
          </div>

          {/* Glowing Circles */}
          <motion.div
            className="absolute -top-32 -left-32 w-[350px] sm:w-[500px] h-[350px] sm:h-[500px] bg-purple-700 opacity-30 rounded-full blur-3xl z-0"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />
          <motion.div
            className="absolute top-0 right-0 w-[200px] sm:w-[300px] h-[200px] sm:h-[300px] bg-blue-500 opacity-20 rounded-full blur-2xl z-0"
            initial={{ scale: 0 }}
            animate={{ scale: 1.2 }}
            transition={{ duration: 1.8, ease: "easeOut" }}
          />

          {/* Hero Content */}
          <motion.div
            className="relative z-10 flex flex-col items-center justify-center space-y-6 text-center"
            variants={container}
            initial="hidden"
            animate="show"
          >
            <motion.h1
              variants={item}
              whileHover={{
                scale: 1.05,
                textShadow: "0px 0px 20px rgba(147, 51, 234, 0.6)",
              }}
              transition={{ type: "spring", stiffness: 300 }}
              className="text-4xl sm:text-5xl md:text-7xl font-extrabold bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 bg-clip-text text-transparent drop-shadow-xl cursor-pointer"
            >
              Hi, I'm Karthik Ramesh{" "}
              <motion.span
                animate={{ rotate: [0, 20, -10, 20, -10, 0] }}
                transition={{ duration: 1.2, repeat: Infinity }}
                className="inline-block text-pink-400 ml-2"
              >
                <FaRegHandPaper size={40} className="sm:size-[50px]" />
              </motion.span>
            </motion.h1>

            <motion.h2
              variants={item}
              whileHover={{ rotate: [0, -3, 3, 0] }}
              transition={{ duration: 0.5 }}
              className="text-xl sm:text-2xl md:text-3xl text-blue-300 font-medium cursor-pointer"
            >
              <h2 className="font-heading text-blue-300 text-xl sm:text-2xl">
                Full-Stack Developer
              </h2>
              <p className="text-sm sm:text-base text-gray-400">
                Based in Boston, Massachusetts USA
              </p>
            </motion.h2>

            <motion.p
              variants={item}
              className="max-w-md sm:max-w-xl text-base sm:text-lg text-gray-300 leading-relaxed px-2"
            >
              I design thoughtful UIs, engineer scalable APIs, and love turning
              ideas into interactive experiences.
            </motion.p>

            {/* Buttons */}
            <motion.div
              variants={item}
              className="flex flex-col sm:flex-row gap-4 pt-4 w-full sm:w-auto justify-center"
            >
              <motion.button
                whileHover={{ scale: 1.08 }}
                whileTap={{ scale: 0.95 }}
                className="bg-gradient-to-r from-purple-600 to-blue-500 hover:from-blue-600 hover:to-purple-500 text-white px-6 py-2 rounded-full text-lg shadow-md transition-all duration-300"
                onClick={()=>window.open("/Karthik_ramesh_resume.pdf")}
              >
                Download Resume
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.08 }}
                whileTap={{ scale: 0.95 }}
                className="border border-blue-400 text-blue-300 hover:bg-blue-500 hover:text-white px-6 py-2 rounded-full text-lg transition-all duration-300"
                onClick={() => navigate("/contact")}
              >
                Contact Me
              </motion.button>
            </motion.div>
          </motion.div>
        </main>
      </main>
    </>
  );
}
